// DS: i3.30
import React from 'react';
import IconWrap, { Props } from '../../IconWrap';

const ChangeSkin: React.FC<Props> = props => {
  return (
    <IconWrap {...props}>
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16">
        <path
          d="M8 1.333c3.682 0 6.667 2.652 6.667 5.926a3.705 3.705 0 01-3.704 3.704h-1.31a1.11 1.11 0 00-1.112 1.111c0 .281.112.54.282.733.178.2.289.46.289.748a1.12 1.12 0 01-1.111 1.112A6.667 6.667 0 018 1.333zm-.792 10.741a2.442 2.442 0 012.445-2.445h1.31a2.372 2.372 0 002.371-2.369c0-2.5-2.355-4.593-5.333-4.593a5.333 5.333 0 00-.451 10.648 2.434 2.434 0 01-.342-1.241zM5.001 8a1 1 0 110-2 1 1 0 010 2zm6 0a1 1 0 110-2 1 1 0 010 2zM8 6a1 1 0 110-2 1 1 0 010 2z"
          fill="currentColor"
        />
      </svg>
    </IconWrap>
  );
};
ChangeSkin.displayName = 'ChangeSkin';

export default ChangeSkin;
